import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggerLevelType } from '@sc/data-access-models';

export interface AbstractSnackBarData {
  currentSnackBar?: MatSnackBar;
  message: string;
  type?: LoggerLevelType;
}
export interface SnackBarData extends AbstractSnackBarData {
  emoticon?: string;
  title?: string;
}

export interface SnackbarBottomData extends AbstractSnackBarData {
  title?: string;
}
